export const FutureOrdersSummeryGraphsSkeleton = () => {
  return (
    <div className="flex h-[10rem] opacity-20 animate-pulse space-x-[2rem] justify-between">
      <div className="bg-gray-100 rounded-full h-full aspect-square"></div>
      <div className="bg-gray-100 rounded-2xl h-full aspect-square"></div>
      <div className="bg-gray-100 rounded-2xl  flex-1 h-full aspect-square"></div>
    </div>
  );
};
